var exports = {
  "H": "indexCard__6mKLOd",
};

module.exports = exports;
